<template>
  <v-menu
    offset-y
    origin="center center"
    :nudge-bottom="10"
    transition="scale-transition"
  >
    <v-btn flat slot="activator" class="language-switcher" :title="$t('common.language')">
      <img :src="current.flag" :alt="current.title" class="language-flag" />
      {{ current.value.toUpperCase() }}
    </v-btn>
    <v-list class="pa-0">
      <v-list-tile
        v-for="language in languages"
        :key="language.value"
        @click="changeLanguage(language.value)"
      >
        <v-list-tile-action class="language-flag-action">
          <img :src="language.flag" :alt="language.title" class="language-flag" />
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ language.title }}</v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action v-if="language.value === $i18n.locale">
          <v-icon color="primary">check</v-icon>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import { LANGUAGES, setLocale } from "@/i18n";

export default {
  name: "LanguageSwitcher",
  data: () => ({
    languages: LANGUAGES,
  }),
  computed: {
    current() {
      return (
        this.languages.find(({ value }) => value === this.$i18n.locale) ||
        this.languages[0]
      );
    },
  },
  methods: {
    changeLanguage(locale) {
      setLocale(locale);
    },
  },
};
</script>

<style scoped>
.language-switcher {
  min-width: 0;
  padding: 0 8px;
}
.language-flag {
  width: 18px;
  height: 18px;
  margin-right: 6px;
}
.language-flag-action {
  min-width: 32px;
}
</style>
